import React, { useEffect, useRef, useState } from "react";

/** Common Components */
import Buttons from "../../../../components/ui/button/Buttons";
import FormCreator from "../../../../components/forms/FormCreator";
import { clientValuationDetailsFormConfig } from "./clientValuationDetails.formfields.config";
import "../../Clients.scss";
import CardSection from "../../../../components/ui/card/CardSection";
import { useNavigate, useParams } from "react-router-dom";
import CenterModal from "../../../../components/ui/centerModal/CenterModal";
import ValuationData from "./features/valuationData/ValuationData";
import { mapDropdownOptions } from "../../../../components/forms/libs/data/mapDropdownOptions";
import {
  useDeleteSetMutation,
  useGetClientCopyValuationMutation,
  useGetClientValuationByReportWordTempIdMutation,
  useLazyGetClientValuationByValIdQuery,
  useUpdateClientValuationMutation,
} from "../../../../app/services/clientValuationAPI";
import ToastService from "../../../../services/toastService/ToastService";
import {
  decryptUrlData,
  encryptUrlData,
} from "../../../../services/CryptoService";
import AddSetData from "./features/valuationData/AddSetData";
import SwalAlert from "../../../../services/swalService/SwalService";
import PropTypes from "prop-types";

/** Configuration Files */

const ClientValuationDetails = (props) => {
  const clientRef = useRef(null);
  const { id } = useParams();
  const decryptedData = id ? decryptUrlData(id) : {};
  const { valID, planID, clientID, clientData ,clientName} = decryptedData;
  const navigate = useNavigate();
  const [isClientPlanModelOpenPrime,setIsClientPlanModelOpenPrime] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState();
  const [valCopyId, setValCopyId] = useState();
  const [templateModelOpen, setTemplateModelOpen] = useState(false);
  const [formData, setFormData] = useState(clientValuationDetailsFormConfig);
  const {confirm} = SwalAlert()

  const [
    updateClientValuation, {
      isLoading: isClientValuationUpdating,
      isSuccess: isClientValuationUpdated,
      data: clientValuationUpdatedData,
    },] = useUpdateClientValuationMutation();

  const [getClientCopyValuation, {
    isLoading: isGetClientCopyValuationLoading,
    isSuccess: isGetClientCopyValuationSuccess,
    data: clientCopyValuationData
  }] = useGetClientCopyValuationMutation();

  const [getClientValuationsListById, {
    isFetching: isGetClientValuationsFetching,
    isSuccess: isGetClientValuationsSuccess,
    data: clientValuationsData,
  }] = useLazyGetClientValuationByValIdQuery();

  const [
    getClientValuationsListByReportTempId,
    {
      isFetching: isGetClientValuationsByReportTempIdFetching,
      isSuccess: isGetClientValuationByReportTempIdSuccess,
      data: clientValuationByReportTempIdData,
    },
  ] = useGetClientValuationByReportWordTempIdMutation();

  const [deleteSet, {
    isLoading: isSetDeleting,
    isSuccess: isSetDeleted,
    data: setDeleteData
  }] = useDeleteSetMutation();

  const resetForm = () => {
    const form = { ...clientValuationDetailsFormConfig };
    form.initialState = { ...props.initData };
    setFormData(form);
  };

  const handlepreClick = (data) => {
    const req = {
      valID: valID,
      planID: planID,
      clientID: clientData,
    };
    navigate(`/clientDetails/${encryptUrlData(req)}`);
  };

  useEffect(() => {
    if (valID) {
      getClientValuationsListById(valID);
    }
    getClientCopyValuation(planID)
  }, []);

  const handleActionChange = () => {
    setTemplateModelOpen(true);
  };

  const handleManageDataClick = () => {
    if (!selectedTemplate) {
      ToastService.warning("Please select a report template");
      return;
    }
    // setIsClientPlanModelOpen(true);
  };

  const handleManageDataClickPrime=()=>{
    if (!selectedTemplate) {
      ToastService.warning("Please select a report template");
      return;
    }
    setIsClientPlanModelOpenPrime(true);
  }

  const handleCloseModel = () => {
    // setIsClientPlanModelOpen(false);
    setIsClientPlanModelOpenPrime(false)
    setTemplateModelOpen(false);
  };

  const handleDeleteClick = () => {
    confirm(
      "Remove?",
      "Are you sure you want to Remove?",
      "Remove",
      "Cancel"
    ).then((confirmed) => {
      if (confirmed) {
        if (selectedTemplate) {
          deleteSet(selectedTemplate)
        };
      }
    });
  };

  const actionHandler = (actionName, dataField, formData) => {
    if (actionName === "ADD" && dataField === "reportTemplateID") {
      setTemplateModelOpen(true);
    }
    if (actionName === "REMOVE" && dataField === "reportTemplateID") {
      handleDeleteClick()
    }
  };

  const handleTemplateChange = (selected) => {
    setSelectedTemplate(selected);
  };

  const handleUpdateClick = () => {
    const formData = clientRef.current.getFormData();
    if (formData) {
      const planYearBegin = new Date(formData.planYearBegin);
      const planYearEnd = new Date(formData.planYearEnd);

      if (planYearBegin > planYearEnd) {
        ToastService.warning("Start Date cannot be after End Date.");
        return;
      }

      if (planYearEnd < planYearBegin) {
        ToastService.warning("End Date cannot be before Start Date.");
        return;
      }

      const req = {
        valID: valID,
        planID: planID,
        valName: formData.valName,
        planYearBegin,
        planYearEnd,
        wordDocID:
          formData.wordDocID === "object"
            ? formData.wordDocID.value
            : formData.wordDocID,
        reportTemplateID:
          typeof formData.reportTypeId === "object"
            ? formData.reportTemplateID.value
            : formData.reportTemplateID,
        copyValID: formData?.copyValID?.value,
        clientName: props.clientName,
      };
      updateClientValuation(req);
    }
  };


  useEffect(() => {
    if (isGetClientCopyValuationSuccess && clientCopyValuationData) {
      mapDropdownOptions(
        clientValuationDetailsFormConfig,
        "basicDetailSection",
        "copyValID",
        clientCopyValuationData,
        "copyValID",
        "valName"
      );
    }
  }, [isGetClientCopyValuationSuccess, clientCopyValuationData]);

  useEffect(() => {
    if (isSetDeleted && setDeleteData) {
      if (setDeleteData.errorMessage) {
        ToastService.success(setDeleteData.errorMessage);
        getClientValuationsListById(valID);
        setDataSource([])
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSetDeleted, setDeleteData]);

  useEffect(() => {
    if (isGetClientValuationsSuccess && clientValuationsData) {
      mapDropdownOptions(
        clientValuationDetailsFormConfig,
        "basicDetailSection",
        "reportTemplateID",
        clientValuationsData.reportTemplateList,
        "reportTemplateID",
        "reportTemplateName"
      );

      const defaultTemplateId = clientValuationsData?.reportTemplateList?.[0]?.reportTemplateID;

      if (defaultTemplateId) {
        setSelectedTemplate(defaultTemplateId);
        getClientValuationsListByReportTempId(defaultTemplateId);
      }
    }
  }, [isGetClientValuationsSuccess, clientValuationsData]);


  useEffect(() => {
    if (
      isGetClientValuationByReportTempIdSuccess &&
      clientValuationByReportTempIdData
    ) {
      mapDropdownOptions(
        clientValuationDetailsFormConfig,
        "basicDetailSection",
        "wordDocID",
        clientValuationByReportTempIdData,
        "wordDocID",
        "wordDocPathAndName"
      );
      mapDropdownOptions(
        clientValuationDetailsFormConfig,
        "basicDetailSection",
        "xmlReportId",
        clientValuationByReportTempIdData,
        "xmlReportId",
        "xmlReportName"
      );

      let updatedForm = { ...formData };

      updatedForm.initialState = {
        ...updatedForm.initialState,
        wordDocID: clientValuationByReportTempIdData[0]?.wordDocID || null,
        wordDocPathAndName:
          clientValuationByReportTempIdData[0]?.wordDocPathAndName || "",
        xmlReportId: clientValuationByReportTempIdData[0]?.xmlReportId || null,
        xmlReportName:
          clientValuationByReportTempIdData[0]?.xmlReportName || "",
      };

      setFormData(updatedForm);
    }
  }, [
    isGetClientValuationByReportTempIdSuccess,
    clientValuationByReportTempIdData,
  ]);

  const onFormFieldChange = (dataField, updatedData) => {
    if (dataField == "copyValID") {
      setValCopyId(updatedData?.copyValID?.value)
    }
    let updatedForm = { ...formData };
    if (dataField === "reportTemplateID") {
      if (updatedData && updatedData.reportTemplateID.value) {
        getClientValuationsListByReportTempId(
          updatedData.reportTemplateID.value
        );
        setSelectedTemplate(updatedData.reportTemplateID.value);
        updatedForm.initialState = {
          ...updatedForm.initialState,
          updatedData: updatedData,
          reportTemplateID:
            typeof updatedData.reportTemplateID === "object"
              ? updatedData.reportTemplateID.value
              : updatedData.reportTemplateID,
          wordDocID: updatedData.wordDocID,
          xmlReportId: updatedData.updatedData,
        };
      }
    }
    setFormData(updatedForm);
  };

  useEffect(() => {
    if (isGetClientValuationsSuccess && clientValuationsData) {
      let updatedForm = { ...formData };

      updatedForm.initialState = {
        ...updatedForm.initialState,
        valName: clientValuationsData.valName,
        copyValID: clientValuationsData.copyValID,
        planYearBegin: clientValuationsData.planYearBegin
          ? new Date(clientValuationsData.planYearBegin)
          : null,
        planYearEnd: clientValuationsData.planYearEnd
          ? new Date(clientValuationsData.planYearEnd)
          : null,
        wordDocID: clientValuationsData.wordDocID,
        reportTemplateID:
          clientValuationsData.reportTemplateList.length > 0
            ? clientValuationsData.reportTemplateList[0]?.reportTemplateID
            : null,
        wordDocPathAndName:
          clientValuationByReportTempIdData &&
          clientValuationByReportTempIdData[0]?.wordDocPathAndName,
        xmlReportId:
          clientValuationByReportTempIdData &&
          clientValuationByReportTempIdData[0]?.xmlReportId,
        xmlReportName:
          clientValuationByReportTempIdData &&
          clientValuationByReportTempIdData[0]?.xmlReportName,
        xMLDocument: clientValuationsData.xMLDocument,
      };

      setDataSource(clientValuationsData);
      setFormData(updatedForm);
    }
  }, [isGetClientValuationsSuccess, clientValuationsData]);

  useEffect(() => {
    if (isClientValuationUpdated && clientValuationUpdatedData) {
      const msg = clientValuationUpdatedData?.errorMessage ?? "";
  
      if (msg.includes("NO RECORD FOUND") || msg.includes("exist")) {
        ToastService.warning(msg);
      } else {
        ToastService.success(msg);
        props.onSuccess?.();
      }
  
      getClientValuationsListById(valID);
    }
  }, [isClientValuationUpdated, clientValuationUpdatedData]);
  
  
  return (
    <>
        <div className="row" style={{maxWidth:"75%"}}>
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-12">
            <CardSection
              cardTitle={"Plan Information"}
              rightButton={true}
              buttonClassName={"blue-btn"}
              titleButtonClick={handlepreClick}
              buttonText={"Back"}
              searchInput={false}
              isButtonVisible={true}
              isButtonLoading={""}
              isIcon={true}
              iconClass="ic:round-arrow-back"
            >
              <div className="valuation-details">
                <div className="top-info-sec">
                  <div className="section-view">
                    <div className="section-view">
                      <div className="row top-desc-sec mb-1">
                        <div className="col-12 mb-2 mt-2">
                          <div className="label-value">
                            <h5 className="label">
                              <span>Plan Name</span>
                              <b>:&nbsp;&nbsp;</b>
                            </h5>

                            <span className="value">
                              {dataSource?.planName || "-"}
                            </span>
                          </div>
                        </div>

                        <div className="col-12 mb-2">
                          <div className="label-value">
                            <h5 className="label">
                              <span>Plan Number</span>
                              <b>:&nbsp;&nbsp;</b>
                            </h5>
                            <span className="value">
                              {dataSource?.planNumber || "-"}
                            </span>
                          </div>
                        </div>
                        <div className="col-12 d-flex">
                        <div className="label-value">
                            <h5 className="label">
                              <span>Year Month</span>
                              <b>:&nbsp;&nbsp;</b>
                            </h5>
                            <span className="value">
                              {dataSource?.planYearMonth || "-"}
                            </span>
                          </div>
                          <div className="label-value ml-5 width-title">
                            <h5 className="label">
                              <span>Year Day</span>
                              <b>:&nbsp;&nbsp;</b>
                            </h5>
                            <span className="value">
                              {dataSource?.planYearDay || "-"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </CardSection>
          </div>
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-12">
            <CardSection
              cardTitle={"Valuation"}
              searchInput={false}
              isButtonVisible={true}
              isButtonLoading={""}
              isIcon={true}
              iconClass="ic:round-arrow-back"
            >
              <div className="valuation-details">
                <div className="form-section">
                  <div className="form-sec">
                    {isGetClientValuationsSuccess && (
                      <FormCreator
                        ref={clientRef}
                        config={formData}
                        onActionChange={actionHandler}
                        onFormFieldChange={onFormFieldChange}
                      />
                    )}
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-button-group-1">
                      <Buttons
                      buttonText="Manage Data"
                      buttonTypeClassName="btn info-btn w-full"
                      onClick={handleManageDataClickPrime}
                      isLoading={false}
                    />
                    <Buttons
                      buttonText="Update"
                      buttonTypeClassName="btn blue-btn w-full"
                      onClick={handleUpdateClick}
                      isLoading={false}
                    />
                  </div>
                </div>
              </div>
            </CardSection>
          </div>
        </div>
      <CenterModal
        modalTitle={`Report Template`}
        modalSize={"w-30"}
        isOpen={templateModelOpen}
        onClose={() => handleCloseModel()}
        transition={"grow"}
      >
        <AddSetData
          onClose={handleCloseModel}
          valID={valID}
          onSuccess={() => {
            getClientValuationsListById(valID);
            setTemplateModelOpen(false);
          }}
        />
      </CenterModal>
      
      <CenterModal
        modalTitle={`Valuation Data : ${clientValuationsData?.valName}`}
        modalSize={"w-85"}
        isOpen={isClientPlanModelOpenPrime}
        onClose={handleCloseModel}
        transition={"grow"}
      >    
         
        <ValuationData valID={valID} selectedTemplate={selectedTemplate} valCopyId={valCopyId} isPrime={isClientPlanModelOpenPrime} clientName={clientName} planYearBegin={dataSource?.planYearBegin} reportType={dataSource?.reportType} PlanNumber={dataSource?.planNumber}/>
      </CenterModal>
    </>
  );
};

ClientValuationDetails.propTypes = {
  clientName: PropTypes.string,
  onSuccess: PropTypes.func
};

export default ClientValuationDetails;
